<template>
    <common-page flex-column card-content>
        <query-view ref="queryView"
                    config-code="em_arch_fixed_asset_disposal"
                    disable-row-check
                    custom-columns="costCenterCode">
            <template #custom(costCenterCode)="{row}">
                {{ costCenterText(row.costCenterCode, row.costCenterName) }}
            </template>
        </query-view>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import QueryView from "@/components/common/display/query-view/QueryView.vue";
import {costCenterText} from "@/views/em/asset/costCenterText";

/**
 * 固定资产处置 | 查询页（验收 #13；URS 需求_new R46–R53 / R69 / R71）。
 * <p>
 * 列表与筛选全部来自 QueryView 配置 em_arch_fixed_asset_disposal
 * （src/model/em/asset/EmArchFixedAssetDisposal.jsc-import.json，service = em-archive）。
 * QueryView 的筛选条是由「可见列」自动派生的：
 *   销账时间 writeOffTime（Date → Between 区间）、发起时间 applyTime（Date → Between 区间）、
 *   资产状态 assetStatus（select → In）、处置类型 disposalType（select → In）
 *   —— 正好覆盖 #13 要求的四项；另外还带上工单号 / 固资号 / 申请人 / 当前处理人 / 处置意见 /
 *   流程状态，无需另配筛选表。
 * <p>
 * <b>为什么 from 是明细表 EmArchFixedAssetDisposalItem 而不是主表：</b>
 * 「固资号 / 子固资号 / 资产名称 / 资产状态」在 URS R51–R57 里同样标了「查询」，
 * 而这些字段落在明细上（一条处置单 N 个资产）。若 from 用主表再 join 明细，
 * 一条处置单会被乘成 N 行、分页数也跟着错（S7 已知约束）；反过来以明细为 from、
 * 向上 join 主表是多对一，不会乘行。因此本查询页是「资产维度」的：
 * 每行 = 一条处置单里的一个资产，Excel 导出同样是资产维度。
 * <p>
 * 流程状态列用的是 status（BPMN task id）配静态选项，而不是 join
 * EM_ACT_PROCESS_DEFINITION_REGISTER_PDR + EM_ACT_PROCESS_STATUS 取 statusName：
 * 后者是运行时数据，缺行时整列会是空白且不报错（S6 已知约束）。
 * <p>
 * Excel 导出用 QueryView 自带的导出按钮。
 */
export default {
    name: "EmArchFixedAssetDisposalQueryView",
    components: {QueryView, CommonPage},
    methods: {
        costCenterText,
    },
}
</script>

<style scoped>
</style>
